(function(root, factory) {

    // NOTE: Adapted from: https://github.com/umdjs/umd/blob/master/templates/returnExports.js
    // Until we move the webpack, we still need to use the amd format for core's r.js
    if (typeof define === 'function' && define.amd) {
        // NOTE: requirejs isn't able to follow relative dependencies in AMD so we're using this
        // "absolute" path. It's defined in the require_base_config.js file in core to point to the
        // LazyString.js file w/in this module. It's a pretty nasty co-dependency, but hopefully
        // a very temporary one for when we can move off of requirejs
        define(['js-utils/lazy-gettext/LazyString'], factory);
    } else if (typeof module === 'object' && module.exports) {
        module.exports = factory(require('./LazyString'));
    }
})(this, function(LazyString) { // eslint-disable-line babel/no-invalid-this, prefer-arrow-callback
    return function lazyGettext(msgid, interpolation) {
        return new LazyString(msgid, interpolation);
    };
});
